module.exports = __webpack_public_path__ + "img/screenshot_240_w.edeefd05.jpg";